module.exports = __webpack_public_path__ + "media/images/hero_images/security-1200-c5c40f625e7131012ab401ee5b464122.jpg";